export const generateFileURL = (file: File | string | null) => {
	if (file instanceof File) {
		return URL.createObjectURL(file);
	}

	return file;
};
